import LectureLessonListResourceListResultModel from '../../generated/types/model/resource/LectureLessonListResourceListResultModel';

export default class LectureLessonListResourceListResultViewModel extends LectureLessonListResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
